import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import { FaUserCircle } from 'react-icons/fa';
import './Navbar.css';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';


const Navbar = () => {
  const [userExist, setUserExist] = useState(false);
  const [userName, setUserName] = useState('');
  const [categories, setCategories] = useState([]);
  const token = localStorage.getItem('jwtToken');
  const logoStyle = {
    width: '150px',
    height: 'auto',
  };
  const fetchCategories = async () => {
    try {
      const response = await axios.get('https://stage-cni-backend.vercel.app/getAllCategories'); // Replace with your API endpoint
      setCategories(response.data.categories);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  const navigate = useNavigate();

  const activeLinkStyle = {
    color: 'blue', // Replace with your desired active link color
  };

  useEffect(() => {
    console.log('navbar');
    if (token) {
      setUserExist(true);
      const decodedToken = jwtDecode(token);
      const id = decodedToken.id;

      axios
        .get(`https://stage-cni-backend.vercel.app/getUserById/${id}`)
        .then((response) => {
          setUserName(response.data['username']);
        })
        .catch((error) => {
          // Handle errors if needed
        });
    }
  }, [token]);

  const logout = () => {
    // Clear the JWT token from local storage
    localStorage.removeItem('jwtToken');

    // Clear the JWT cookie by setting it to expire immediately
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Set the userExist state to false (assuming it's a state variable you are using)
    setUserExist(false);

    // Navigate to the SignIn page
    navigate('/SignIn');
  };

  const goToSignUp = () => {
    navigate('/SignUp');
  };

  const goToSignIn = () => {
    navigate('/SignIn');
  };

  const goToHome = () => {
    navigate('/');
  };

  const [activeLink, setActiveLink] = useState('home'); // State to keep track of the active link
  const [activeCategorie, setActiveCategorie] = useState(false); // State to keep track of the active link
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(null);
  // ...

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const handleCategorieClick = () => {
    setActiveCategorie(true);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
      <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5" onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); handleLinkClick('home') }}>
        <img
          src="../assetsTemplates/template1/img/logo.jpg"
          alt="eLEARNING Logo"
          className="logo-image me-3"
          style={logoStyle}
        />
      </Link>
      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">
          <Link
            to="/"
            className={`nav-item nav-link ${activeLink === 'home' ? 'active' : ''}`}
            onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); handleLinkClick('home') }} // Set the active link to 'about' when the about link is clicked
          >
            Home
          </Link>
          <Link
            to="/About"
            className={`nav-item nav-link ${activeLink === 'about' ? 'active' : ''}`}
            onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); handleLinkClick('about') }} // Set the active link to 'about' when the about link is clicked
          >
            About
          </Link>
          <Link
            to="/Projects"
            className={`nav-item nav-link ${activeLink === 'project' ? 'active' : ''}`}
            onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); handleLinkClick('project') }} // Set the active link to 'project' when the project link is clicked
          >
            Projects
          </Link>
          <div className="nav-item dropdown">
            <Link to="#" className={`nav-link dropdown-toggle ${activeCategorie ? 'active' : ''}`} data-bs-toggle="dropdown">
              Categories
            </Link>
            <div className="dropdown-menu fade-down m-0">
              {categories.map((category, index) => (
                <Link
                  to={`/categories/${category._id}`}
                  className={`dropdown-item ${activeCategoryIndex === index ? 'active' : ''}`}
                  onClick={() => {
                    setActiveCategoryIndex(index);
                    setActiveCategorie(true); // Keep your existing logic here
                    setActiveLink(''); // Keep your existing logic here
                  }}
                  key={category._id}
                >
                  {category.nom}
                </Link>
              ))}
            </div>
          </div>
          <Link
            to="/Contact"
            className={`nav-item nav-link ${activeLink === 'contact' ? 'active' : ''}`}
            onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); handleLinkClick('contact') }} // Set the active link to 'contact' when the contact link is clicked
          >
            Contact
          </Link>
        </div>
        {!userExist ? (
          <>
            <button onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); goToSignIn(); setActiveLink(''); }} className="btn btn-light py-2 px-3 d-none d-lg-block custom-button" style={{ fontWeight: "400" }}>
              <i className="fas fa-sign-in-alt"></i> Sign In
            </button>
            <button onClick={() => { setActiveCategoryIndex(null); setActiveCategorie(false); goToSignUp(); setActiveLink(''); }} className="btn btn-primary py-2 px-3 d-none d-lg-block custom-button ms-2 " style={{ fontWeight: "400" }}> 
              <i className="fas fa-user-plus"></i> Sign Up
            </button>
          </>
        ) : (
          <div className="nav-item dropdown">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              id="userDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="icon-and-username">
                <FaUserCircle className="user-icon" />
                <span className="username">{userName}</span>
              </span>
            </button>
            <ul className="dropdown-menu" aria-labelledby="userDropdown">
              <li>
                <button className="dropdown-item" onClick={logout}>Logout</button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

